// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/custom.scss
// module id = pgpf
// module chunks = 6